import { getCurUser } from '../constants/fromLocalStorageConstants';
import { API, graphqlOperation } from 'aws-amplify';
import { updateSnippet } from '@/graphql/mutations';
import { listSnippets } from '@/graphql/queries';
export const oldSnippetsBackfill = async () => {
  const res = await API.graphql(
    graphqlOperation(listSnippets, {
      filter: {
        owner: {
          eq: getCurUser().email,
        },
      },
    })
  );
  res.data.listSnippets.items.map((snippet) =>
    !snippet.identityID
      ? API.graphql(
          graphqlOperation(updateSnippet, {
            input: {
              id: snippet.id,
              identityID: getCurUser().identityID,
            },
          })
        )
      : 0
  );
};
